<p-listbox
	[options]="menuOptions"
	[(ngModel)]="user.preferences.menusHidden"
	[multiple]="true"
	optionValue="key"
	optionLabel="label"
	[listStyle]="{ 'max-height': '225px' }"
	optionGroupChildren="items"
	checkbox="true"
	group="true"
	[filter]="true"
	filterPlaceHolder="Search..."
	(onChange)="changesToSaveChange.emit(true); userService.savePreference()"
>
	<ng-template pTemplate="header">
		<div class="d-flex mx-2"><i>Select the menus you would like to hide.</i></div>
	</ng-template>
	<ng-template let-rec pTemplate="item">
		<div class="">
			<div>{{ rec.label }}</div>
		</div>
	</ng-template>
</p-listbox>
